/**
 * Created by sasik on 3/29/16.
 */

var EAN = {
    format:"EAN",
    height: 200,

};

var QR = {
    height: 200,
    text: "size doesn't matter"
};

var Barcode = {
    TYPE_TEXT : 1,
    TYPE_QR : 2,
    TYPE_EAN : 3,

    TYPE_ID : '#barcode-generator-type',
    CODE_ID : '#barcode-generator-code',
    ELEMENTS_CLASS : '.barcode-generator',
    CODE_GENERATED_PLACE_ID : '#bardcode-generator-place',

    getTypeElement : function () {
        return $(Barcode.TYPE_ID);
    },

    getCodeElement : function () {
        return $(Barcode.CODE_ID);
    },

    getCodePlace : function () {
        return $(Barcode.CODE_GENERATED_PLACE_ID);
    },


    getAll : function () {
        return $(Barcode.ELEMENTS_CLASS);
    },

    render : function (type, code) {
        Barcode.getCodePlace().empty();
        if (Barcode.TYPE_TEXT == type) {
            var $elem = $('<input disabled class="form-control" value="' + code + '" >');
            Barcode.getCodePlace().append($elem);
        } else if (Barcode.TYPE_EAN == type) {

            var $canvas = $('<canvas></canvas>').JsBarcode(code, EAN);
            // var $canvas = ioBarcode.EAN(code, EAN);
            Barcode.getCodePlace().append($canvas);
        } else if (Barcode.TYPE_QR == type) {
            var qr = QR;
            qr.text = code;
            Barcode.getCodePlace().qrcode(qr);
        }
    },

    clear : function () {
        Barcode.getCodePlace().empty();
    },

    handle : function() {
        var $type = Barcode.getTypeElement();
        var $code = Barcode.getCodeElement();
        Barcode.render($type.val(), $code.val());
    },

    init : function () {
        var $elements = Barcode.getAll();

        $elements.on('change', function () {
            Barcode.handle();

        });
    }

};

Barcode.init();
Barcode.handle();

